import Cookies from 'js-cookie';

document.addEventListener('DOMContentLoaded', () => {
  const cookiesEl = document.querySelector('.cookies');
  if (!cookiesEl) return;

  const cookiesBtns = cookiesEl.querySelector('.cookies__btns');
  const cookiesSettings = cookiesEl.querySelector('.cookies__sett');
  const customizeBtn = cookiesEl.querySelector('.accept-cust');
  const acceptAllBtn = cookiesEl.querySelector('.accept-all');
  const saveBtn = cookiesEl.querySelector('.accept-send');

  const userConsent = Cookies.get('user_finforce_cookies');
  if (userConsent) return;

  setTimeout(() => {
    cookiesEl.classList.add('is-opened');
  }, 5000);

  acceptAllBtn?.addEventListener('click', () => {
    Cookies.set('user_finforce_cookies', 'all', { expires: 365 });
    cookiesEl.classList.remove('is-opened');
  });

  customizeBtn?.addEventListener('click', () => {
    cookiesBtns?.classList.remove('is-active');
    cookiesSettings?.classList.add('is-active');
  });

  saveBtn?.addEventListener('click', event => {
    event.preventDefault();

    const selectedPrefs = {};
    const inputs = cookiesEl.querySelectorAll('.cookies__checkbox input');

    if (inputs.length) {
      inputs.forEach(input => {
        selectedPrefs[input.name] = input.checked;
      });
    }

    Cookies.set('user_finforce_cookies', JSON.stringify(selectedPrefs), {
      expires: 365,
    });

    cookiesEl.classList.remove('is-opened');
  });
});

// Отримати збережені налаштування
function getUserConsent() {
  const consentRaw = Cookies.get('user_finforce_cookies');
  if (!consentRaw) return null;

  try {
    const consent = JSON.parse(consentRaw);
    return consent;
  } catch {
    return consentRaw;
  }
}
